export default __webpack_public_path__ + "static/media/fenge_s.fc173eee.png";